import helpers from '../helpers';
import constants from '../constants';

class RGBColor {
  constructor(red, green, blue, alpha = 1) {
    this.red = red;
    this.green = green;
    this.blue = blue;
    this.alpha = alpha;
    helpers.checkRange(red, 1, 'red');
    helpers.checkRange(green, 1, 'green');
    helpers.checkRange(blue, 1, 'blue');
    helpers.checkRange(alpha, 1, 'alpha');
  }

  toCSSValue() {
    return `rgba(${100 * this.red}%, ${100 * this.green}%, ${100 * this.blue}%, ${this.alpha})`;
  }

  round() {
    return new RGBColor(
      Math.round(255 * this.red) / 255,
      Math.round(255 * this.green) / 255,
      Math.round(255 * this.blue) / 255,
      this.alpha
    );
  }

  equals({ red, green, blue, alpha }) {
    const { COMMON } = constants;
    return (
      Math.abs(this.red - red) < COMMON.ACCURACY &&
      Math.abs(this.green - green) < COMMON.ACCURACY &&
      Math.abs(this.blue - blue) < COMMON.ACCURACY &&
      Math.abs(this.alpha - alpha) < COMMON.ACCURACY
    );
  }
}

export default RGBColor;
